import { render } from "./Branches.vue?vue&type=template&id=643b988c&scoped=true"
import script from "./Branches.vue?vue&type=script&lang=js"
export * from "./Branches.vue?vue&type=script&lang=js"

import "./Branches.vue?vue&type=style&index=0&id=643b988c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-643b988c"

export default script